import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import bakkoura from "../../Assets/Projects/bakkoura.JPG";
import chips from "../../Assets/Projects/chips.JPG";
import DirtySockers from "../../Assets/Projects/dirty.JPG";
import cars from "../../Assets/Projects/1.PNG";
import stephanie from "../../Assets/Projects/Capture.PNG";
import narative from "../../Assets/Projects/Capturre.JPG";
import Beestate from "../../Assets/Projects/Capture1 - Copy.JPG";
import Cyborg from "../../Assets/Projects/Cyborg.png";
import movies from "../../Assets/Projects/movies.PNG";
import Tale from "../../Assets/Projects/Tale.JPG";
import Restaurant from "../../Assets/Projects/menu.JPG";
import RUBIC from "../../Assets/Projects/RUBIC.JPG";
/* import socialmedia from "../../Assets/Projects/social-media.JPG"; */
import shopping from "../../Assets/Projects/shopping.JPG";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bakkoura}
              isBlog={false}
              title="bakkoura"
              description="A website for Syrian businessman and watch designer Gehad Bakkoura in which he presents his new works with a watch in the form of a character who closes his eyes every five minutes."
              ghLink="https://github.com/Mohamed-Gamal-G/bakkoura"
              demoLink="https://www.bakkourawink.com/"
              FigmaLink="https://www.figma.com/file/WwRoPDGsRSbME25Fw2RTn7/Bakkoura?type=design&t=EUvawS8NJI4RLRtO-6"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chips}
              isBlog={false}
              title="Cedar Valley Chips"
              description="a high school project food product business.
                          He teamed up with his mother, Surria Fadel, to bring their family’s recipes to market — initially focusing on a traditional Fattoush salad dressing inspired by their."
              ghLink="https://github.com/Mohamed-Gamal-G/cedar-valley"
              demoLink="https://cedarvalley.vercel.app/"
              FigmaLink="https://www.figma.com/file/MmgNQEgexIkLGluP4PdtQZ/Untitled-(Copy)?type=design&node-id=0-1&mode=design&t=JFToHUyA5ckNWEVm-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={DirtySockers}
              isBlog={false}
              title="Dirty Sockers"
              description="A collection of 10,000 unique, degen Dirty Sockers NFTs and 100 OG Sockers NFTs, that promote freedom, individuality, and diversity in the NFT space and give back to the community."
              ghLink="https://github.com/Mohamed-Gamal-G/dirtysockers"
              demoLink="https://dirtysockers.vercel.app/"
              FigmaLink="https://www.figma.com/file/hO1NgPyi7WOgvNxoLYbeZD/Shared-Design?type=design&mode=design&t=Hwdsnpf0cHPQwucF-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={shopping}
              isBlog={false}
              title="E-commerce-Shopping"
              description="This project showcases product listing, search, category filter, sorting, pagination, and shopping cart functionality."
              ghLink="https://github.com/Mohamed-Gamal-G/E-commerce-Shopping"
              demoLink="https://e-commerce-shopping-kappa-seven.vercel.app/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={cars}
              isBlog={false}
              title=" Ingenieurteam "
              description="Mechanical Engineering website professional car services across the Germany"
              ghLink="https://github.com/Mohamed-Gamal-G/INGENIEURTEAM-PUBLIC"
              demoLink="https://ingenieurteam-chi.vercel.app/"
              FigmaLink="https://www.figma.com/file/Ulvybiu6imrpqeDvUQMeCW/Web-ST--Ingenieurteam?type=design&node-id=52-894&mode=design&t=Hwdsnpf0cHPQwucF-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={stephanie}
              isBlog={false}
              title="stephanie"
              description="landing page For a marketing company"
              ghLink="https://github.com/Mohamed-Gamal-G/stephanie-nu"
              demoLink="https://stephanie-nu.vercel.app/"
              FigmaLink="https://www.figma.com/file/aq8TMrTVfQZAzCxd4EkhwP/Stephanie-Benedetti-Landing-Page?type=design&mode=design&t=Hwdsnpf0cHPQwucF-0"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={narative}
              isBlog={false}
              title="narative"
              description="an independent studio building impactful products"
              demoLink="https://mohamed-gamal2.surge.sh/"
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Beestate}
              isBlog={false}
              title="Be Estate"
              description="Furniture store"
              ghLink=""
              demoLink="https://mohamed-gamal1.surge.sh/"
              FigmaLink=""
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Cyborg}
              isBlog={false}
              title="Cyborg"
              description=""
              ghLink="https://github.com/Mohamed-Gamal-G/Cyborg"
              demoLink="https://cyborg.surge.sh/"
              FigmaLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={movies}
              isBlog={false}
              title="movies"
              description=""
              ghLink=""
              demoLink="https://mohamed-gamal4.surge.sh/"
              FigmaLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Tale}
              isBlog={false}
              title="Tale"
              description="An SEO improvement company "
              ghLink="https://github.com/Mohamed-Gamal-G/Tale"
              demoLink="https://mohamed-gamal-g.github.io/Tale/"
              FigmaLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={Restaurant}
              isBlog={false}
              title="Restaurant"
              description=""
              ghLink="https://github.com/Mohamed-Gamal-G/Restaurant"
              demoLink="https://mohamed-gamal-g.github.io/Restaurant/inex.html"
              FigmaLink=""
            />
          </Col>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={RUBIC}
              isBlog={false}
              title="RUBIC"
              description="Landing page"
              ghLink="https://github.com/Mohamed-Gamal-G/RUBIC"
              demoLink="https://mohamed-gamal-g.github.io/RUBIC/"
              FigmaLink=""
            />
          </Col>
          {/*       <Col md={4} className="project-card">
            <ProjectCard
              imgPath={socialmedia}
              isBlog={false}
              title="socialmedia"
              description=""
              ghLink="https://github.com/Mohamed-Gamal-G/social-media"
              demoLink="https://mohamed-gamal-g.github.io/social-media/"
              FigmaLink=""
            />
          </Col> */}

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
